import React from "react";
import DataTable from "react-data-table-component";

const Table = ({
  columns,
  data,
  totalRows,
  currentPage,
  onPageChange,
  limit,
  onRowsPerPageChange,
  waterMark,
}) => {
  //  No Data Image
  const NoDataIndication = () => (
    <div className="test">
      <div className="empty-state">
        <div className="empty-icon">📊</div>
        <h3>No Data Available</h3>
        <p>Adjust your filters or check back later for trading results</p>
      </div>
    </div>
  );


  // ✅ watermark overlay style
const watermarkOverlayStyle = {
  position: "absolute",
  inset: 0,
  backgroundImage: `url(${localStorage.getItem("watermark")})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "contain",
  opacity: 0.40,        
  pointerEvents: "none", 
  zIndex: 0,
};

return (
  <div
    className="table-responsive"
    style={{ ...tableContainerStyle, position: "relative" }}
  >
    {waterMark && <div style={watermarkOverlayStyle} />}

    <div style={{ position: "relative", zIndex: 1 }}>
      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationDefaultPage={currentPage}
        onChangePage={onPageChange}
        striped
        customStyles={customStyles}
        responsive={true}
        paginationRowsPerPageOptions={[10, 25, 50, 100]}
        onChangeRowsPerPage={onRowsPerPageChange}
        paginationPerPage={limit}
        paginationComponentOptions={{
          rowsPerPageText: "Rows per page:",
          noRowsPerPage: false,
        }}
        noDataComponent={<NoDataIndication />}
      />
    </div>
  </div>
);
};

const tableContainerStyle = {
  borderRadius: "10px",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  display: "block",
  maxWidth: "100%",
  overflowX: "auto", // ✅ agar column jyada ho toh scroll aayega
  position: "relative",
};

const customStyles = {
  header: {
    style: {
      minHeight: "60px",
      backgroundColor: "#4CAF50",
      color: "#fff",
      fontSize: "16px",
      fontWeight: "1000",
      borderRadius: "10px 10px 0 0",
      textAlign: "center",
    },
  },
  headRow: {
    style: {
      borderBottomWidth: "2px",
      borderBottomColor: "#ddd",
      borderBottomStyle: "solid",
      backgroundColor: "#f1f1f1",
    },
  },
  headCells: {
    style: {
      fontWeight: "bold",
      fontSize: "12px",
      color: "#333",
      // padding: "10px 20px",
      textAlign: "center",
      whiteSpace: "normal", // ✅ nowrap हटाओ
      wordBreak: "break-word", // ✅ लंबा text wrap हो जाएगा
    },
  },
  cells: {
    style: {
      // padding: "12px 20px",
      fontSize: "11px",
      color: "#555",
      fontWeight: "bold",
      backgroundColor: "#fff",
      borderBottom: "1px solid #eee",
      textAlign: "center",
      transition: "background-color 0.3s",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    activeStyle: {
      backgroundColor: "#e7f7e7",
    },
  },
  rows: {
    highlightOnHoverStyle: {
      backgroundColor: "#f0f8ff",
      cursor: "pointer",
    },
    stripedStyle: {
      backgroundColor: "#f9f9f9",
    },
  },
};

export default Table;
